import { HttpInterceptorFn, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs/operators';

import { DiagnosticsBufferService } from './diagnostics-buffer.service';

/**
 * Records METADATA for every HttpClient call into the DiagnosticsBufferService ring
 * buffer (feeds the cable-harness "Report a Bug" flow). Captures method, URL, status,
 * duration and timestamp ONLY — never headers (Authorization) or request/response
 * bodies. Purely observational: it does not modify the request or response.
 */
export const networkLogInterceptor: HttpInterceptorFn = (req, next) => {
  const diagnostics = inject(DiagnosticsBufferService);
  const startedAt = Date.now();
  const ts = new Date(startedAt).toISOString();

  const record = (status: number) => {
    diagnostics.recordNetwork({
      method: req.method,
      url: req.urlWithParams,
      status,
      durationMs: Date.now() - startedAt,
      ts,
    });
  };

  return next(req).pipe(
    tap({
      next: event => {
        if (event instanceof HttpResponse) {
          record(event.status);
        }
      },
      error: err => {
        // status 0 = transport/CORS/abort (no HTTP response reached the client).
        record(err instanceof HttpErrorResponse ? err.status : 0);
      },
    })
  );
};
